// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IssueHistoryForm .h4,
.IssueHistoryForm label,
.IssueHistoryForm .IssueHistoryFormHeader,
.IssueHistoryForm .IssueHistoryFormHistoryTitle {
  color: var(--bs-primary);
}
.IssueHistoryForm .IssueHistoryFormHeader {
  padding-bottom: 1rem;
}
.IssueHistoryForm .IssueHistoryFormHeader > .col {
  display: flex;
  flex-direction: column;
}
.IssueHistoryForm .IssueHistoryFormHeader > .col .IssueHistoryFormTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.IssueHistoryForm .IssueHistoryFormLinkTrips {
  padding-bottom: 0.5rem;
}
.IssueHistoryForm .IssueHistoryFormLinkTrips > .col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.IssueHistoryForm .IssueHistoryFormUpload {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.IssueHistoryForm .IssueHistoryFormHistory {
  padding-bottom: 1rem;
}
.IssueHistoryForm .IssueHistoryFormHistory .IssueHistoryFormHistoryTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.IssueHistoryForm .IssueHistoryFormSectionHeader {
  padding-bottom: 1rem;
}
.IssueHistoryForm .IssueHistoryFormSectionHeader .IssueHistoryFormSummarySectionTitle {
  padding: 0.5rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.IssueHistoryForm .TextArea[name=flightIssueDescription] {
  height: 7rem !important;
  resize: none !important;
}
.IssueHistoryForm .TextArea[name=outboundFlightInfo],
.IssueHistoryForm .TextArea[name=rootCauseDescription] {
  height: 5rem !important;
  resize: none !important;
}
.IssueHistoryForm .btn {
  text-transform: uppercase;
}
.IssueHistoryForm .btn[type=SUBMIT] {
  width: 100%;
  margin: 2rem 0;
}
.IssueHistoryForm .SimpleTable-Controls {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/features/IssueHistory/components/IssueHistoryForm/styles.scss"],"names":[],"mappings":"AACE;;;;EAIE,wBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;AACN;AAAM;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AAER;AAEE;EACE,sBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACN;AAEE;EACE,mBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,wBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,uBAAA;EACA,uBAAA;AAAJ;AAEE;;EAEE,uBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AACI;EACE,WAAA;EACA,cAAA;AACN;AAEE;EACE,wBAAA;AAAJ","sourcesContent":[".IssueHistoryForm {\n  .h4,\n  label,\n  .IssueHistoryFormHeader,\n  .IssueHistoryFormHistoryTitle {\n    color: var(--bs-primary);\n  }\n  .IssueHistoryFormHeader {\n    padding-bottom: 1rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      .IssueHistoryFormTitle {\n        padding: 0.25rem 0 1rem 0;\n        border-bottom: 1px solid #ccc;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .IssueHistoryFormLinkTrips {\n    padding-bottom: 0.5rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  .IssueHistoryFormUpload {\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n  }\n  .IssueHistoryFormHistory {\n    padding-bottom: 1rem;\n    .IssueHistoryFormHistoryTitle {\n      padding: 0.25rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .IssueHistoryFormSectionHeader {\n    padding-bottom: 1rem;\n    .IssueHistoryFormSummarySectionTitle {\n      padding: 0.5rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .TextArea[name='flightIssueDescription'] {\n    height: 7rem !important;\n    resize: none !important;\n  }\n  .TextArea[name='outboundFlightInfo'],\n  .TextArea[name='rootCauseDescription'] {\n    height: 5rem !important;\n    resize: none !important;\n  }\n  .btn {\n    text-transform: uppercase;\n    &[type='SUBMIT'] {\n      width: 100%;\n      margin: 2rem 0;\n    }\n  }\n  .SimpleTable-Controls {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
